import styled, { css, keyframes } from 'styled-components'
import { Variables, Utils } from '@intellihr/ui-components'

const StyledDropzone = styled.div<{ isDragActive: boolean; hasNoFiles: boolean }>`
  overflow: hidden;
  box-sizing: border-box;
  border: 1px solid transparent;

  ${({ isDragActive }) => {
    return (
      isDragActive &&
      css`
        border: 1px solid ${Variables.Color.i300};
        border-radius: ${Variables.Style.borderRadius}px;
      `
    )
  }}

  ${({ hasNoFiles }) => {
    return (
      hasNoFiles &&
      css`
        border: 1px dashed ${Variables.Color.i300};
        border-radius: ${Variables.Style.borderRadius}px;
      `
    )
  }}

  ${Utils.mediaQueryBetweenSizes({ maxPx: Variables.Breakpoint.breakpointTablet })} {
    border: 1px solid transparent;
  }
`

const StyledOverlay = styled.div<{ showOverlay: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: none;
  opacity: 0.05;

  ${({ showOverlay }) => {
    return (
      showOverlay &&
      css`
        display: block;
        background: ${Variables.Color.i300};
      `
    )
  }}
`

const StyledCallToAction = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  left: 0;
  bottom: -16px;
  right: 0;
`

const StyledTextWrapper = styled.div`
  width: 160px;
  height: 36px;
  background: ${Variables.Color.n100};
  border-radius: 8px;
  box-shadow: ${Variables.BoxShadow.bsLv2Prominent};
  margin-top: ${Variables.Spacing.sXSmall}px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`

const moveUpDown = keyframes`
  0%, 100% {
    margin-bottom: 0;
  }
  50% {
    margin-bottom: 10px;
  }
`

const StyledIconWrapper = styled.div<{ shouldAnimate: boolean }>`
  ${({ shouldAnimate }) => {
    return (
      shouldAnimate &&
      css`
        animation: ${moveUpDown} 1.5s ease-in-out infinite;
      `
    )
  }}
`

const StyledWrapper = styled.div<{ showCursor: boolean }>`
  position: relative;

  ${({ showCursor }) =>
    showCursor &&
    css`
      cursor: pointer;
    `}
`

export { StyledIconWrapper, StyledWrapper, StyledCallToAction, StyledTextWrapper, StyledDropzone, StyledOverlay }
